import React, { Component } from 'react';
import EyeIcon from 'mdi-react/EyeIcon';
import { Button, Row, Col, Progress, Card, CardBody, Spinner } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Field, Form } from 'formik';
import { Redirect, withRouter } from 'react-router-dom';
import LoadingIcon from 'mdi-react/LoadingIcon';
import { login, logout, getCurrentUser } from '../../redux/Auth';
import { registerBlocker, unregisterBlocker } from '../../helpers/navigation';
import ModalDialog from '../../components/custom/ModalDialog';
import Recaptcha from '../../components/custom/Recaptcha';
import { Link } from 'react-router-dom';
import log from '../../helpers/logger';
import CheckIcon from 'mdi-react/CheckIcon';
import { setSpinner, registerTopbarLeft } from '../../redux/Global';
import { getQueryString } from '../../helpers/formatter';
import { isEmailFormat, deepEqualX, deepNotEqualX } from '../../helpers/utils';
import { showNotification } from '../../redux/Notification';
import RintagiScreen from '../../components/custom/Screen';
import { requestSignUp, activateAccount, resetSignup } from '../../redux/SignUp';

class SignUp extends RintagiScreen {
  constructor(props) {
    super(props);
    this.lastValidated = {}
    this.state = {
      ModalColor: "",
      ModalTitle: "",
      ModalHeader: false,
      ModalMsg: '',
      ModalClassName: '',
      ModalOpen: false,
      ModalSuccess: null,
      activating: false,
    }

    this.props.registerTopbarLeft("","",true,"","");

    this.props.setSpinner(true);

    this.TokenChange = this.TokenChange.bind(this);
    this.TextChange = this.TextChange.bind(this);
    this.LoseFocus = this.LoseFocus.bind(this);
    this.ValidatePage = this.ValidatePage.bind(this);
    // this.TermsModal = this.TermsModal.bind(this);
    this.confirmUnload = this.confirmUnload.bind(this);
    this.OnModalReturn = this.OnModalReturn.bind(this);
    this.setDirtyFlag = this.setDirtyFlag.bind(this);
    this.onCaptChaChange = this.onCaptChaChange.bind(this);

    this.props.getCurrentUser(true);
  }


  LoseFocus(setFieldTouched, validateField, name) {
    return function (evt) {
      log.debug('lose focus', name);
      setFieldTouched(name, true);
      //validateField(name);
    }
  }
  ValidateField = name => value => {
    log.debug('validate', name, value);
  }


  TextChange(setFieldValue, setFieldTouched, name) {
    const _this = this;
    return function (evt) {
      const value = evt.target.value;
      setFieldTouched(name, true);
      setFieldValue(name, value);
    }
  }

  TokenChange(setFieldValue, setFieldTouched, name) {
    const _this = this;
    return function (evt) {
      const value = evt.target.value;
      setFieldTouched(name, true);
      setFieldValue(name, value.toUpperCase());
    }
  }

  onCaptChaChange(setFieldValue, setFieldTouched, name) {
    return function (evt) {
      console.log(evt);
      setFieldTouched(name, evt);
      setFieldValue(name, evt);
    }
  }

  // TermsModal() {
  //   const _this = this;
  //   // let TiCtext = '<b>Lender/borrower/guarantor</b> commit and abide to the following rules / policy:'
  //   return _this.setState({
  //     ModalOpen: true,
  //     ModalColor: "success",
  //     ModalClassName: 'mw-800',
  //     ModalHeader: true,
  //     ModalTitle: "Terms & Conditions",
  //     ModalMsg: <div dangerouslySetInnerHTML={{
  //       __html: '<div><b>Lender/borrower/guarantor</b> commit and abide to the following rules/policy:<br /><br /><ul><li>All fees and rewards are subject to change without notice;</li><li>Agrees to pay FintruX’s published fees in local dollar equivalent of FTX when requested;</li><li>FintruX charges a fee in FTX/CR/Credit-Card/Fiat on every transaction; in particular, there will be a charge for each partner service agent, processing the loan, maintaining the loan, and administering irregularities</li><li>FTX tokens can be purchased from major exchanges including Qryptos, Hitbtc, Bancor, etc. and all decentralized exchanges;</li><li>Goes through ID/KYC/AML check to verify identity and clean record;</li><br /><br /><li>Guarantors can only be individual for now;</li><li>Lenders must be verified Financial Institution (F/I), Companies in Good Standing (C/O), Accredited Investor (A/I), or Ordinary Citizen (O/C);</li><li>Borrowers must be SME, no consumer is allowed;</li><li>Lender, borrower, and guarantor(s) execute loan agreement directly among each other, FintruX is not a party of the agreement</li><br /><br /><li>FintruX does not handle money, lenders</li><li class="list-none"><ul><li>deposit and withdraw 10% of loan in fiat currencies from licensed trust institution(s) as escrow agent(s) in its jurisdiction, and</li><li>honor blockchain ledger that they create representing the 90% of loan in fiat currency that they are ready to lend, and destroy them immediately when tendered for their fiat currency</li></ul></li><li>FintruX will only bring borrower leads to trust accounts that have a balance of the equivalent of S$5k (minimum loan amount and country dependent) or more in CR blockchain ledger;</li><li>Lender agrees to provide one unique Ethereum address to each of their trust accounts; this wallet address will be used to store CR, tracking of their trust account balance; Lender authorizes FintruX (POA) to transfer the appropriate CR from this address to other addresses on their loan agreements;</li><li>Borrower can use different (recommended) or the same Ethereum address for each loan agreement; fiat currency can be withdrawn from designated trust account in exchange for CR stored in this address;</li><li>Lenders acknowledge that CR is the equivalent of their fiat currency in their trust accounts and it is a ledger; Lenders further agree to take care of their CR as good as money; CR gets created and destroyed as fiat money deposit and withdrawn from their bank accounts; One CR is equivalent to one unit of the named fiat currency at the named trust account.</li><br /><br /><li>FintruX will not provide advice or recommendation to either borrower or lender, only facts, analysis, and popular options will be presented; However, the assignment of credit risk pools will be determined by FintruX’s internal risk rating;</li><li>With the exception of determining credit risk pool, FintruX does not make any decision for any participant (lender, borrower, guarantor, partner service agent, etc.)</li><li>With the exception of onboarding, FintruX does not perform any decisioning service; Lenders pick their service agents to perform ID/KYC/AML/CREDIT/MODEL/DUE-DILIGENCE/COLLECTION on their borrowers</li><li>Lender gives detail instructions how to move how much of their money, and has the ultimate decision who to lend their money to; Borrower has the ultimate decision who to borrower their money from</li><li>FintruX only provides leads to lenders and absolutely will not act as broker to any participant</li><br /><br /><li>Lenders must provide evidence of equivalent knowledge or have attended at least one online course in credit analysis conducted by other accredited instructor or our senior credit analyst which is available to the general public;</li><li>Lenders can make lending decisions at any time, as long as it is reasonable, including but not limited to who to lend, the amount and terms to lend;</li><li>Lenders have full control of their money, no one can access their money without their explicit instructions;</li><li>Borrowers agree to share their credit and financial information with their selected lenders and FintruX;</li><br /><br /><li>Borrowers agree that 10% of their borrowing will be held back in as security deposit in a credit risk pool held by trust-institution to mitigate the risk together with other borrowers;</li><li class="list-none"><ul><li>Borrowers are responsible for all their direct delinquencies and are liable to pay to their lenders excess over 10% their security deposit;</li><li>Lenders should incur the loss should this 10% depleted in the credit risk pool not caused by their borrowers but by other borrowers’ delinquencies;</li></ul></li><li>FintruX’s FTX reserve is distributed proportionally to the same categories of the credit risk pools and only kick-in to pay lender for loan loss when all else failed; this is the last resort;</li><li>Delinquencies longer than six (6) months will automatically passed to partner collection agent selected by lender in advance to pursue defaulted borrowers;</li><li>Partner collection agents have the rights to use all reasonable and legal means to contact and collect from borrower on any defaulted amounts and late charges, including but not limited to telephone calls, site visits, etc.;</li><li>Borrowers are obligated to pay the credit risk pool or FintruX reserve, not the lender, if lenders have been paid by these already;</li><br /><br /><li>Lenders, borrowers, guarantors, partner trust-institutions, and partner servicing agents can rate and comment on each other after funding is completed for one or more loans;</li><li>All owner(s) of borrower SME having 20% or more shareholdings (country dependent) must be registered as a Guarantor and sign as guarantor on the loan agreement.</li><li>A paper loan agreement must be signed electronically by borrower (on behalf of the SME), lender, and at least one guarantor; this agreement will be tied to an immutable smart contract on a public blockchain accessible only by Lender/Borrower/Guarantor; no private information will be stored on any smart contract.</li><li>There are four public smart contracts:</li><li class="list-none"><ul><li>one and only reputation smart contract;</li><li>one and only FTX smart contract for FintruX to process fee payments;</li><li>one CR smart contract for each combination of lender + fiat-currency; and</li><li>one loan smart contract for each loan;</li></ul></li></ul></div>'
  //     }} />
  //   });
  // }

  setDirtyFlag(dirty) {
    /* this is called during rendering but has side-effect, undesirable but only way to pass formik dirty flag around */
    if (dirty) {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = this.confirmUnload;
      registerBlocker(this.confirmUnload);
    }
    else {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    if (this.props.updateChangedState) this.props.updateChangedState(dirty);
    this.SetCurrentRecordState(dirty);
    return true;
  }

  confirmUnload(message, callback) {
    const confirm = () => {
      callback(true);
    }
    const cancel = () => {
      callback(false);
    }
    this.setState({ ModalOpen: true, ModalSuccess: confirm, ModalCancel: cancel, ModalClassName: 'mw-520', ModalHeader: false, ModalColor: "danger", ModalTitle: 'Unsaved Changes', ModalMsg: 'You have unsaved changes on this page. Are you sure you want to leave?' });
  }

  /* field validators */
  ValidateFullName = (isTouched, setFieldTouched, setFieldValue, values) => value => {
    log.debug('validate password', value.length);
    if (this.FormGroup && this.FormGroup !== "SignUp") return;
    if (!value) return 'Please enter your full name';
  }

  ValidateEmail = (isTouched, setFieldTouched, setFieldValue, values) => value => {
    log.debug('validate email', isTouched, value);
    if (this.FormGroup && this.FormGroup !== "SignUp") return;
    if (!value) return 'Please enter your email address'
    if (!isEmailFormat(value)) return 'Please enter a valid email address'
    // if (this.lastValidated.email !== value || this.IsFormSubmit) {
    if (this.IsFormSubmit) {
      this.lastValidated.email = value;
      // return signUpService.emailAvailable(value).then(
      //   result => {
      //     log.debug(result);
      //   },
      //   err => {
      //     log.debug(err);
      //     throw 'email not available';
      //   }
      // )
    }
    else {
      log.debug('not touched, skip expensive validation')
    }
  }
  ValidatePassword = (isTouched, setFieldTouched, setFieldValue, values) => value => {
    log.debug('validate password', value.length);
    if (this.FormGroup && this.FormGroup !== "SignUp") return;
    if (!value) return 'Please enter your password'
    if (value.length < 8) return 'Your password must be at least 8 characters long'
  }

  ValidateReTypePassword = (isTouched, setFieldTouched, setFieldValue, values) => value => {
    log.debug('validate retype password');
    if (this.FormGroup && this.FormGroup !== "SignUp") return;
    if (values.password !== value) return "Your passwords don't match";
  }

  // ValidateAgree = (isTouched, setFieldTouched, setFieldValue, values) => value => {
  //   log.debug('validate term agreed', value);
  //   if (this.FormGroup && this.FormGroup !== "SignUp") return;
  //   if (!value) return "Your must agree to terms and conditions to proceed";
  // }

  ValidateRecaptcha = (isTouched, setFieldTouched, setFieldValue, values) => value => {
    log.debug('recaptcha checked', value);
    if (this.FormGroup && this.FormGroup !== "SignUp") return;
    if (!value) return "Your must check the recaptcha to proceed";
  }

  ValidateToken = (isTouched, setFieldTouched, setFieldValue, values) => value => {
    log.debug('validate token', value);
    if (this.FormGroup && this.FormGroup !== "Activate") return;
    if (!value) return "Please enter your confirmation code from the email";
  }

  /* end field validators */
  ValidatePage(values) {
    /* formik form validation, only non-field level validation should go to here. field validation should be done at individual level and they are always called by formik 
       inter field validation should be done here
    */
    const errors = {};

    log.debug('form validate triggered');
    if (values.retypePassword !== values.password) {
      errors.retypePassword = "Your passwords don't match";
    }

    // if (!values.agree) {
    //   errors.agree = "Your must agree to terms and conditions to proceed";
    // }

    console.log(values.recaptcha);

    if (!values.recaptcha) {
      errors.recaptcha = "Your must check the recaptcha to proceed";
    }

    this.IsFormSubmit = false; // this is used by field validator and needs to be reset when we are here   
    this.FormGroup = undefined; // this is used by field validator and needs to be reset when we are here   

    return errors;
  }

  SubmitForm = formGroup => (evt) => {
    /* 
    this is intended to be used as OnClick for form submission. would be run BEFORE actual submit so we can use state/instance variable
    to control ValidatePage() behavior as Formik cannot distinguish between field level triggered validation and form level triggered validation
    */
    this.IsFormSubmit = true;
    this.FormGroup = formGroup;
    this.FormAction = formGroup;
    /* block further, uncomment 
    evt.preventDefault();
    evt.stopPropagation();
    */
  }

  resendEmail = (values) => {
    const signUpRequest = this.props.signup;
    log.debug(this.state.email, this.state.password, "", signUpRequest.nounce, values.token, signUpRequest.ticketRight)
    this.props.activateAccount(this.state.email, this.state.password, "", signUpRequest.nounce, values.token, signUpRequest.ticketRight);
  }

  ActivateAccount = (values, { setSubmitting, validateField }) => (evt) => {
    this.setState({ activating: true, submitting: true, setSubmitting: setSubmitting });
    const signUpRequest = this.props.signup;
    this.props.activateAccount(signUpRequest.email, signUpRequest.password, signUpRequest.role, signUpRequest.nounce, values.token, signUpRequest.ticketRight, getQueryString("refCode"));
  }

  signUp = (values, { setSubmitting }) => {
    log.debug('signup request submitted');
    const recaptchaTicket = values.recaptcha;
    const signUpRequest = this.props.signup;
    this.IsFormSubmit = false;
    this.setState({ submittedOn: Date.now(), submitting: true, setSubmitting: setSubmitting });
    if (this.FormAction === "SignUp") {
      this.props.requestSignUp(values.fullName, values.email, values.password, recaptchaTicket, getQueryString(this.props.history.location, "refCode"));
      this.props.setSpinner(true);
    }
    else if (this.FormAction === "ResendEmail") {
      this.props.requestSignUp(values.fullName, values.email, values.password, "", getQueryString(this.props.history.location, "refCode"));
      this.props.showNotification("EMAIL HAS BEEN SENT", { message: 'Verification email has been resent' });
    }
    else if (this.FormAction === "Activate") {
      this.setState({ activating: true, email: values.email, password: values.password });
      log.debug(values.fullName, values.email, values.password, "", signUpRequest.nounce, values.token, signUpRequest.ticketRight)
      this.props.activateAccount(values.fullName, values.email, values.password, "", signUpRequest.nounce, values.token, signUpRequest.ticketRight, getQueryString(this.props.history.location, "refCode"))
        .catch((e) => {
          log.debug(e);
          this.props.showNotification('E', { message: 'Confirmation code is incorrect' });
          this.setState({ activating: false, submitting: false, });
          setSubmitting(false);
        })
        .finally(() => {

        })
    }
    this.FormAction = undefined;
  }

  componentDidUpdate(prevProps, prevStates) {
    if (!(this.props.signup || {}).loading && this.props.global.pageSpinner) {
      const _this = this;
      setTimeout(() => _this.props.setSpinner(false), 500);
    }
    if (this.state.submitting &&
      !(this.props.signup || {}).loading
    ) {
      this.state.setSubmitting(false);
    }

    const currentLogin = this.props.user || {};
    const currentSignUp = this.props.signup || {};
    const selectedRole = this.props.global.role || {};
    log.debug(currentLogin, this.state, this.props.signUp);
    if (currentLogin.UsrId) {
      this.props.resetSignup();
      // this.props.history.push(selectedRole.landingPage)
      this.props.history.push('/Onboarding')
    }
    else {
      if (!this.state.loginTried && this.props.signup.usrId && !currentLogin.loading) {
        this.setState({ loginTried: true });
        this.props.login(this.state.email, this.state.password);
      }
    }
  }

  componentWillUnmount() {
    if (this.blocker) {
      unregisterBlocker(this.blocker);
      this.blocker = null;
    }
  }

  render() {
    if (this.props.user && this.props.user.UsrId) {
      if (((this.props.location.state || {}).from || {}).pathname) {
        log.debug('here1');
        return <Redirect to={((this.props.location.state || {}).from || {}).pathname + ((this.props.location.state || {}).from || {}).search} />
      }
      else {
        log.debug('here2');
        return <Redirect to='/' />
      }
    }

    const sigUpRequest = this.props.signup;
    const user = this.props.user;
    const envPublicUrl = process.env.PUBLIC_URL;
    const termsAndConditions = envPublicUrl + '/helper/TermsAndConditions.pdf';
    log.debug(user, sigUpRequest);
    log.debug(this.state);

    return (
      <div>
        <div className='account'>
          <div className='account__wrapper'>
            <div className='account__card'>
              <div className='account__head'>
                <h3 className='project-title'>Create Your Account</h3>
                {/* <h4 className='account__subhead subhead'>Sign up here to get started</h4> */}
              </div>
              <Formik
                initialValues={{
                  fullName: '',
                  email: '',
                  password: '',
                  retypePassword: '',
                  // agree: true,
                  token: '',
                  recaptcha: ''
                }}
                validate={this.ValidatePage}
                validateOnChange={true}
                validateOnBlur={true}
                onSubmit={this.signUp}
                render={({
                  values,
                  errors,
                  touched,
                  isSubmitting,
                  dirty,
                  setFieldValue,
                  setFieldTouched,
                  handleChange,
                  submitForm,
                  validateField,
                  setSubmitting,
                }) => (
                    <Form className='form'> {/* this line equals to <form className='form' onSubmit={handleSubmit} */}
                      {!sigUpRequest.nounce &&
                        <div className='w-100'>
                          <div className='form__form-group'>
                            <label className='form__form-group-label'>Full Name <span className="text-danger">*</span></label>
                            <div className='form__form-group-field'>
                              <Field
                                type="text"
                                name="fullName"
                                value={values.fullName}
                                validate={this.ValidateFullName(touched.fullName, setFieldTouched, setFieldValue, values)}
                              />
                            </div>
                            {errors.fullName && touched.fullName && <span className='form__form-group-error'>{errors.fullName}</span>}
                          </div>
                          <div className='form__form-group'>
                            <label className='form__form-group-label'>Email <span className="text-danger">*</span></label>
                            <div className='form__form-group-field'>
                              <Field
                                type="text"
                                name="email"
                                value={values.email}
                                onBlur={this.LoseFocus(setFieldTouched, validateField, "email")}
                                validate={this.ValidateEmail(touched.email, setFieldTouched, setFieldValue, values)}
                              />
                            </div>
                            {errors.email && touched.email && <span className='form__form-group-error'>{errors.email}</span>}
                          </div>
                          <div className='form__form-group'>
                            <label className='form__form-group-label'>Password <span className="text-danger">*</span></label>
                            <div className='form__form-group-field'>
                              <Field
                                type='password'
                                name="password"
                                value={values.password}
                                validate={this.ValidatePassword(touched.password, setFieldTouched, setFieldValue, values)}
                              />
                            </div>
                            <span className='form__form-group-description'>
                              Must be at least 8 characters
                        </span>
                            {errors.password && touched.password && <span className='form__form-group-error'>{errors.password}</span>}
                          </div>
                          <div className='form__form-group'>
                            <label className='form__form-group-label'>Retype Password <span className="text-danger">*</span></label>
                            <div className='form__form-group-field'>
                              <Field
                                type='password'
                                name="retypePassword"
                                value={values.retypePassword}
                                validate={this.ValidateReTypePassword(touched.retypePassword, setFieldTouched, setFieldValue, values)}
                              />
                            </div>
                            {errors.retypePassword && touched.retypePassword && <span className='form__form-group-error'>{errors.retypePassword}</span>}
                          </div>
                          {/* <div className='form__form-group'>
                            <div className='form__form-group-field'>
                              <label className='checkbox-btn checkbox-btn--colored-click mr-20'>
                                <Field
                                  className='checkbox-btn__checkbox'
                                  type='checkbox'
                                  name='agree'
                                  onChange={handleChange}
                                  value={values.agree}
                                  checked={values.agree}
                                  validate={this.ValidateAgree(touched.agree, setFieldTouched, setFieldValue, values)}
                                // defaultChecked={values.agree}
                                />
                                <span className='checkbox-btn__checkbox-custom'><CheckIcon /></span>
                              </label>
                              <span className='checkbox-btn__label fw-300 ml-10'>By signing up, I agree to the <a className="color-green pointer" href={termsAndConditions} target="_blank">terms and conditions</a>, which may change from time to time.</span>
                            </div>
                            {errors.agree && touched.agree && <span className='form__form-group-error'>{errors.agree}</span>}
                          </div> */}
                          <div className='form__form-group'>
                            <div className='form__form-group-field'>
                              <Recaptcha
                                name='recaptcha'
                                value={values.recaptcha}
                                onChange={this.onCaptChaChange(setFieldValue, setFieldTouched, "recaptcha")}
                                validate={this.ValidateRecaptcha(touched.recaptcha, setFieldTouched, setFieldValue, values)}
                              />
                            </div>
                            {errors.recaptcha && touched.recaptcha && <span className='form__form-group-error'>{errors.recaptcha}</span>}
                          </div>
                           <div className='form__form-group'>
                            <span>By clicking 'Sign Up' you agree to receive emails on useful tips, deals and offers from Rintagi. In addition, you also agree to Rintagi's Terms of Service and Privacy Policy.</span>
                         
                          </div>
                          <Button
                            color='success'
                            className='btn btn-success account__btn'
                            type="submit"
                            onClick={this.SubmitForm('SignUp')}
                            disabled={isSubmitting}>
                            Sign up
                          </Button>
                          <div className='form__form-group text-center mt-20'>
                            <Link className="fill-fintrux" to='/login'><u>Already have an account?</u></Link>
                          </div>
                        </div>
                      }
                      {sigUpRequest.nounce &&
                        <div className='w-100'>
                          <div className='form__form-group'>
                            <label className='form__form-group-label fw-400'>
                              A confirmation code is sent to <span className="color-green"><b>{values.email}</b></span>. Please check your email inbox.</label>
                          </div>
                          <div className='form__form-group'>
                            <label className='form__form-group-label'>Confirmation Code <span className="text-danger">*</span></label>
                            <div className='form__form-group-field'>
                              <Field
                                type="text"
                                name="token"
                                // disabled={!sigUpRequest.nounce}
                                onChange={this.TokenChange(setFieldValue, setFieldTouched, "token")}
                                value={values.token}
                                validate={this.ValidateToken(touched.token, setFieldTouched, setFieldValue, values)}
                              />
                            </div>
                            {errors.token && touched.token && <span className='form__form-group-error'>{errors.token}</span>}
                          </div>
                          <Button
                            color="success"
                            type='submit'
                            onClick={this.SubmitForm('Activate')}
                            disabled={isSubmitting || !sigUpRequest.nounce || this.state.activating}
                            className="btn btn-success account__btn">
                            {this.state.activating && <Spinner color="secondary" style={{ width: '20px', height: '20px', marginRight: '5px', verticalAlign: '-5px' }} />} {this.state.activating ? 'Activating...' : 'Activate'}
                          </Button>
                          <div className='form__form-group text-center mt-20'>
                            <button type='submit' className="btn fill-fintrux" onClick={this.SubmitForm('ResendEmail')}><u>Resend an email</u></button>
                          </div>
                        </div>
                      }
                    </Form>
                  )}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: (state.auth || {}).user,
  error: state.error,
  global: state.global,
  signup: state.signup
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    {
      setSpinner: setSpinner,
      showNotification: showNotification,
      requestSignUp: requestSignUp,
      activateAccount: activateAccount,
      resetSignup: resetSignup,
      login: login,
      getCurrentUser: getCurrentUser,
      registerTopbarLeft: registerTopbarLeft,
    },
  ), dispatch)
)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignUp));



// WEBPACK FOOTER //
// ./src/pages/login/SignUp.js